import {
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { useNavigate } from "react-router";

const LegalixLogo = () => {
  // Desktop sidebar is collapsible="none" (always expanded); mobile uses a sheet.
  // Always show the wordmark — the favicon branch was for icon-collapse mode.
  return (
    <div className="my-2 flex h-10 items-center justify-center">
      <div
        dir="ltr"
        aria-label="Legalix.AI Logo"
        className="flex w-full select-none items-center justify-center gap-1 font-[Poppins] text-3xl font-semibold"
      >
        <span className="text-violet-950">Legalix.</span>
        <span className="gradient-ai">AI</span>
      </div>
    </div>
  );
};

const Header = () => {
  const navigate = useNavigate();

  return (
    <SidebarHeader>
      <SidebarMenu>
        <SidebarMenuItem onClick={() => navigate("/")}>
          <SidebarMenuButton asChild tooltip="Legalix.AI">
            <LegalixLogo />
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarHeader>
  );
};

export default Header;
